<template>
	<div id="app"  v-if="$route.name == 'login' || $route.name == 'register' || $route.name == null">
		<router-view></router-view>
	</div>
	<div id="app" class="flex" v-else>
		<Vmenuleft></Vmenuleft>			
		<div id="app_right">
			<router-view></router-view>
			<div class="alert alert-warning alert_msg" role="alert" v-if="get_show_alert_error()">{{get_alert_msg_error()}}</div>
            <div class="alert alert-success alert_msg" role="alert" v-if="get_show_alert_success()">{{get_alert_msg_success()}}</div>
			<div class="note_noti" v-if="note_noti != ''">
				<span class="text_notify">{{note_noti}}</span>
				<span class="close_notifi" title="Tắt thông báo" @click="closeNotify">&times;</span>
			</div>
		</div>
	</div>
</template>

<script>
import Vmenuleft from '@/components/common/MenuLeft'
import io from 'socket.io-client'
import {mapGetters} from 'vuex'
import { setInterval, setTimeout } from 'timers'
import {callApi, execute_notifications, sendDevice} from '@/helper/function'
import axios from 'axios'



export default {
	name: 'App',
	components : {
		Vmenuleft
	},
	data(){
		return {
			interval: '',
			note_noti: '', // dòng thông báo trên header
			tab_active: true, // trạng thái tab browser có đang đc mở không (true: đang mở; false: đang ở tab khác)
			notifi: {}, // thông tin cài đặt notifi			
		}
	},
	created(){
		
		let ls = localStorage
		let vchat_user = ls.getItem('vchat_user')
		let userInfo = JSON.parse(vchat_user)
		this.$store.commit('set_user', JSON.parse(vchat_user))


	},
	methods: {
		/**
		 * get_notifychat: lấy tổng số tin nhắn chưa trả lời trong store
		 */
		...mapGetters(['get_alert_msg_error','get_alert_msg_success','get_show_alert_error','get_show_alert_success']),
		
		

		closeNotify(){
			this.note_noti = ''
		},


	},
	watch: {
		show_alert_error(n,o){},
		show_alert_success(n,o){}
	}
}
</script>